<div class="add-farm-component">
    <div [formGroup]="farmFormGroup">
        <div class="farm-header-row">
            <div class="accordion-header">
                <h3 class="main-title">Farm {{ index + 1 }}</h3>
            </div>
            <div class="delete-farm-popup">
                <button
                    type="button"
                    (click)="removeFarm()"
                    title="Delete this farm"
                >
                    <i class="fas fa-trash-alt"></i> <span>Delete Farm</span>
                </button>
            </div>
        </div>
        <div class="farm-top-group">
            <!-- First Row: Name and Address -->
            <div class="farm-form-row">
                <div class="input-group-farm">
                    <label for="name{{ index }}"
                        >Name:<span class="text-danger-required">*</span></label
                    >
                    <input
                        id="name{{ index }}"
                        formControlName="name"
                        class="form-control"
                        placeholder="Enter farm name"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('name'),
                            'is-valid':
                                !isControlInvalid('name') &&
                                farmFormGroup.get('name').touched
                        }"
                    />
                    <div
                        *ngIf="
                            farmFormGroup.get('name').invalid &&
                            farmFormGroup.get('name').touched
                        "
                        class="invalid-feedback"
                    >
                        Farm name is required.
                    </div>
                </div>

                <div class="input-group-farm">
                    <label for="address{{ index }}"
                        >Address:<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="address{{ index }}"
                        formControlName="address"
                        class="form-control"
                        placeholder="Enter farm address"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('address'),
                            'is-valid':
                                !isControlInvalid('address') &&
                                farmFormGroup.get('address').touched
                        }"
                    />
                    <div
                        *ngIf="
                            farmFormGroup.get('address').invalid &&
                            farmFormGroup.get('address').touched
                        "
                        class="invalid-feedback"
                    >
                        Farm address is required.
                    </div>
                </div>
            </div>

            <!-- Second Row: Bird Type, Breed, and Measurements -->
            <div class="farm-form-row">
                <div class="input-group-farm">
                    <label for="type{{ index }}"
                        >Bird Type:<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <select
                        formControlName="type"
                        id="type{{ index }}"
                        class="form-control"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('type'),
                            'is-valid':
                                !isControlInvalid('type') &&
                                farmFormGroup.get('type').touched
                        }"
                    >
                        <option value="0" disabled selected>
                            Select Bird Type
                        </option>
                        <option
                            *ngFor="let bird of birdTypes"
                            [value]="bird.id"
                        >
                            {{ bird.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            farmFormGroup.get('type').invalid &&
                            farmFormGroup.get('type').touched
                        "
                        class="invalid-feedback"
                    >
                        <span *ngIf="farmFormGroup.get('type').errors?.required"
                            >Please select a bird type.</span
                        >
                        <span *ngIf="farmFormGroup.get('type').errors?.min"
                            >Please select a bird type from the list.</span
                        >
                    </div>
                </div>

                <!-- BREED FIELD - COMMENTED OUT - TO BE ADDED LATER -->
                <!-- <div class="input-group-farm">
                    <label class="label"
                        >Breed<span class="text-danger-required">*</span></label
                    >
                    <select
                        formControlName="breedId"
                        id="breed{{ index }}"
                        class="form-control"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('breedId'),
                            'is-valid':
                                !isControlInvalid('breedId') &&
                                farmFormGroup.get('breedId').touched
                        }"
                    >
                        <option value="0" disabled selected>
                            Select Breed
                        </option>
                        <option *ngFor="let breed of breeds" [value]="breed.id">
                            {{ breed.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            farmFormGroup.get('breedId').invalid &&
                            farmFormGroup.get('breedId').touched
                        "
                        class="invalid-feedback"
                    >
                        <span
                            *ngIf="
                                farmFormGroup.get('breedId').errors?.required
                            "
                            >Please select a breed.</span
                        >
                        <span *ngIf="farmFormGroup.get('breedId').errors?.min"
                            >Please select a breed from the list.</span
                        >
                    </div>
                </div> -->

                <div class="input-group-farm">
                    <label for="length{{ index }}"
                        >Farm Length (m):<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="length{{ index }}"
                        formControlName="length"
                        type="number"
                        min="0"
                        step="0.01"
                        class="form-control"
                        placeholder="0.00"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('length'),
                            'is-valid':
                                !isControlInvalid('length') &&
                                farmFormGroup.get('length').touched
                        }"
                    />
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            farmFormGroup.get('length').invalid &&
                            (farmFormGroup.get('length').touched ||
                                farmFormGroup.get('length').dirty)
                        "
                    >
                        <span
                            *ngIf="farmFormGroup.get('length').errors?.required"
                            >Farm length is required.</span
                        >
                        <span
                            *ngIf="farmFormGroup.get('length').errors?.['min']"
                            >Length must be greater than 0.</span
                        >
                    </div>
                </div>

                <div class="input-group-farm">
                    <label for="width{{ index }}"
                        >Farm Width (m):<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="width{{ index }}"
                        formControlName="width"
                        class="form-control"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0.00"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('width'),
                            'is-valid':
                                !isControlInvalid('width') &&
                                farmFormGroup.get('width').touched
                        }"
                    />
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            farmFormGroup.get('width').invalid &&
                            (farmFormGroup.get('width').touched ||
                                farmFormGroup.get('width').dirty)
                        "
                    >
                        <span
                            *ngIf="farmFormGroup.get('width').errors?.required"
                            >Farm width is required.</span
                        >
                        <span *ngIf="farmFormGroup.get('width').errors?.min"
                            >Width must be greater than 0.</span
                        >
                    </div>
                </div>

                <div class="input-group-farm">
                    <label for="size{{ index }}"
                        >Farm Size (m²):<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="size{{ index }}"
                        formControlName="size"
                        type="number"
                        readonly
                        class="form-control readonly-field"
                        placeholder="0.00"
                    />
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            farmFormGroup.get('size').invalid &&
                            (farmFormGroup.get('size').touched ||
                                farmFormGroup.get('size').dirty)
                        "
                    >
                        <span *ngIf="farmFormGroup.get('size').errors?.required"
                            >Farm size is required.</span
                        >
                        <span *ngIf="farmFormGroup.get('size').errors?.min"
                            >Size must be greater than 0.</span
                        >
                    </div>
                </div>
                 <div class="input-group-farm">
                    <label for="waterTank{{ index }}"
                        >Water Tank Capacity (l):<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="waterTank{{ index }}"
                        formControlName="waterTank"
                        type="number"
                        min="0"
                        step="0.01"
                        class="form-control"
                        placeholder="0.00"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('waterTank'),
                            'is-valid':
                                !isControlInvalid('waterTank') &&
                                farmFormGroup.get('waterTank').touched
                        }"
                    />
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            farmFormGroup.get('waterTank').invalid &&
                            (farmFormGroup.get('waterTank').touched ||
                                farmFormGroup.get('waterTank').dirty)
                        "
                    >
                        <span
                            *ngIf="farmFormGroup.get('waterTank').errors?.required"
                            > Water Tank is required.</span
                        >
                        <span
                            *ngIf="farmFormGroup.get('waterTank').errors?.['min']"
                            > Water Tank must be greater than 0.</span
                        >
                    </div>
                </div>
                 <div class="input-group-farm">
                    <label for="dieselTank{{ index }}"
                        >Diesel Tank Capacity (l):<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="dieselTank{{ index }}"
                        formControlName="dieselTank"
                        type="number"
                        min="0"
                        step="0.01"
                        class="form-control"
                        placeholder="0.00"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('dieselTank'),
                            'is-valid':
                                !isControlInvalid('dieselTank') &&
                                farmFormGroup.get('dieselTank').touched
                        }"
                    />
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            farmFormGroup.get('dieselTank').invalid &&
                            (farmFormGroup.get('dieselTank').touched ||
                                farmFormGroup.get('dieselTank').dirty)
                        "
                    >
                        <span
                            *ngIf="farmFormGroup.get('dieselTank').errors?.required"
                            > Diesel Tank is required.</span
                        >
                        <span
                            *ngIf="farmFormGroup.get('dieselTank').errors?.['min']"
                            > Diesel Tank must be greater than 0.</span
                        >
                    </div>
                </div>
                <div class="input-group-farm">
                    <label for="waterTankHeight{{ index }}"
                        >Water Tank Height (mm):<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="waterTankHeight{{ index }}"
                        formControlName="waterTankHeight"
                        type="number"
                        min="0"
                        step="0.01"
                        class="form-control"
                        placeholder="0.00"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('waterTankHeight'),
                            'is-valid':
                                !isControlInvalid('waterTankHeight') &&
                                farmFormGroup.get('waterTankHeight').touched
                        }"
                    />
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            farmFormGroup.get('waterTankHeight').invalid &&
                            (farmFormGroup.get('waterTankHeight').touched ||
                                farmFormGroup.get('waterTankHeight').dirty)
                        "
                    >
                        <span
                            *ngIf="farmFormGroup.get('waterTankHeight').errors?.required"
                            > Water Tank Height is required.</span
                        >
                        <span
                            *ngIf="farmFormGroup.get('waterTankHeight').errors?.['min']"
                            > Water Tank must be greater than 0.</span
                        >
                    </div>
                </div>               

                 <div class="input-group-farm">
                    <label for="dieselTankHeight{{ index }}"
                        >Diesel Tank Height (mm):<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="dieselTankHeight{{ index }}"
                        formControlName="dieselTankHeight"
                        type="number"
                        min="0"
                        step="0.01"
                        class="form-control"
                        placeholder="0.00"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('dieselTankHeight'),
                            'is-valid':
                                !isControlInvalid('dieselTankHeight') &&
                                farmFormGroup.get('dieselTankHeight').touched
                        }"
                    />
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            farmFormGroup.get('dieselTankHeight').invalid &&
                            (farmFormGroup.get('dieselTankHeight').touched ||
                                farmFormGroup.get('dieselTankHeight').dirty)
                        "
                    >
                        <span
                            *ngIf="farmFormGroup.get('dieselTankHeight').errors?.required"
                            > Diesel Tank Height is required.</span
                        >
                        <span
                            *ngIf="farmFormGroup.get('dieselTankHeight').errors?.['min']"
                            >  Diesel Tank Height must be greater than 0.</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <div formArrayName="farmHouses" class="farm-farm-house-group">
            <div
                class="farmhouse"
                *ngFor="
                    let farmHouseGroup of farmHouses.controls | slice: 1;
                    let j = index
                "
                [formGroupName]="j + 1"
            >
                <div class="farmhouse-header-row">
                    <div class="accordion-header" (click)="setOpenFarm(j)">
                        <h3>Farmhouse {{ j + 1 }}</h3>
                        <i
                            class="fas fa-chevron-down"
                            [ngClass]="{rotate: openFarmIndex === j}"
                        ></i>
                    </div>
                    <button
                        class="btn btn-remove-farmhouse"
                        type="button"
                        (click)="removeFarmHouse(j + 1)"
                        title="Remove this farmhouse"
                    >
                        <i class="fas fa-trash-alt"></i>
                    </button>
                </div>
                <div
                    class="accordion-body"
                    [ngClass]="{show: openFarmIndex === j}"
                >
                    <app-add-farmhouse
                        [farmHouseFormGroup]="farmHouseGroup"
                        [index]="j + 1"
                        (removeFarmHouseEvent)="removeFarmHouse($event)"
                        (addFarmHousePartitionEvent)="
                            addFarmHousePartition($event)
                        "
                    >
                    </app-add-farmhouse>
                </div>
            </div>
            <button
                type="button"
                class="btn btn-action-secondary"
                (click)="addFarmHouse()"
                title="Add a new farmhouse"
            >
                <i class="fas fa-plus"></i> Add Farmhouse
            </button>
        </div>
    </div>
</div>
